import { resourceString } from '../../../providers/translation';

export const BRAIN_ACCURACY_MESSAGES = {
    STILL_LEARNING: resourceString('You need to tag more images for the classes below:'),
    LOW: resourceString('We recommend you keep tagging more images for the following classes:'),
    GOOD: resourceString(
        'Enough images of each class have been tagged. This is a good time to start testing your brain and validating whether you need to keep going. If you do want to get a Great score, make sure you have at least 50 tagged images for each class and that the accuracy for each class is greater than 90%.'
    ),
    GREAT: resourceString(
        "At this point, there are enough images tagged for each class, it's perfectly fine to stop here."
    )
};

export const BRAIN_ACCURACY_DESCRIPTORS = {
    NOT_AVAILABLE: resourceString('N/A'),
    STILL_LEARNING: resourceString('Still Learning'),
    LOW: resourceString('Low'),
    GOOD: resourceString('Good'),
    GREAT: resourceString('Great')
};

export const MIN_ASSETS_FOR_CLASS = 5;

export const CHART_ORDER_DROPDOWN = {
    SORT_ALPHABETICAL: 0,
    SORT_ACCURACY_ASC: 1,
    SORT_ALPHABETICAL_REVERSE: 2,
    SORT_ACCURACY_DESC: 3,
    SORT_IMAGE_COUNT_ASC: 4,
    SORT_IMAGE_COUNT_DESC: 5
};

export const CHART_DATA_CONTEXT = {
    CLASS_DATA: 0,
    IMAGE_DATA: 1
};

export const HINT_TYPES = {
    PROBLEM_CLASSES: 0,
    INSUFFICIENT_ASSETS: 1
};



// WEBPACK FOOTER //
// ./src/components/workspace/accuracy/constants.ts